import { motion } from "framer-motion";

const reasons = [
  {
    title: "Custom-Designed Solutions",
    desc: "Every box is engineered to your product's exact dimensions and requirements.",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
      </svg>
    ),
  },
  {
    title: "Cost-Efficient Manufacturing",
    desc: "Optimised production lines keep unit costs low without compromising quality.",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8V6m0 12v-2m0-10a9 9 0 110 18A9 9 0 0112 2z" />
      </svg>
    ),
  },
  {
    title: "In-House Design & Testing",
    desc: "Structural design, prototyping, and load testing all under one roof.",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    title: "Reliable Quality & Consistency",
    desc: "Strict QC at every stage ensures every batch meets the same high standard.",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
      </svg>
    ),
  },
  {
    title: "Logistics Support",
    desc: "Pallet-optimised sizing and stacking specs that reduce shipping costs.",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10l2 .001M13 16l2 .001M13 16V8h5l3 5v3h-2" />
      </svg>
    ),
  },
  {
    title: "Export-Ready Packaging",
    desc: "Compliant with international shipping standards for global distribution.",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    title: "On-Time Delivery",
    desc: "Production schedules built around your deadlines, not ours.",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    title: "Customer-Focused Service",
    desc: "A dedicated team that stays responsive from first quote to final delivery.",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay },
});

export default function WhyUs() {
  return (
    <section className="py-28 bg-dark text-white relative overflow-hidden">

      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-[0.03]"
        style={{ backgroundImage: "radial-gradient(circle, white 1px, transparent 1px)", backgroundSize: "32px 32px" }}
      />

      {/* Green glow top-right */}
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-brand-green/10 blur-3xl pointer-events-none" />
      {/* Green glow bottom-left */}
      <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-brand-green/8 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6">

        {/* Header */}
        <motion.div {...fadeUp(0)} className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="block w-8 h-px bg-brand-lightGreen" />
            <span className="text-brand-lightGreen text-xs uppercase tracking-[0.2em] font-semibold">Our Advantage</span>
            <span className="block w-8 h-px bg-brand-lightGreen" />
          </div>
          <h2 className="font-heading text-4xl md:text-5xl mb-4">Why Choose PMS Packages</h2>
          <p className="text-gray-400 max-w-xl mx-auto text-base leading-relaxed">
            We don't just manufacture boxes — we deliver packaging engineered
            to protect your products and simplify your operations.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid md:grid-cols-4 gap-4">
          {reasons.map((item, index) => (
            <motion.div
              key={index}
              {...fadeUp(0.04 + index * 0.04)}
              className="group relative p-6 rounded-2xl border border-white/8 bg-white/4 hover:bg-white/8 hover:border-brand-green/40 transition-all duration-300 backdrop-blur-sm"
            >
              {/* Icon */}
              <div className="w-10 h-10 rounded-xl bg-brand-green/15 text-brand-lightGreen flex items-center justify-center mb-4 group-hover:bg-brand-green group-hover:text-white transition-all duration-300">
                {item.icon}
              </div>

              <h4 className="font-heading text-base font-semibold mb-2 leading-snug text-white">
                {item.title}
              </h4>
              <p className="text-gray-400 text-sm leading-relaxed group-hover:text-gray-300 transition-colors duration-300">
                {item.desc}
              </p>

              {/* Bottom accent line on hover */}
              <div className="absolute bottom-0 left-6 right-6 h-px bg-brand-green scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left rounded-full" />
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}